












































































































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { AutenticacaoRemota, StatusDaAutenticacaoRemota, TipoDaAutenticacaoRemota } from '@/models/usuario/Usuario'
import axios, { CancelTokenSource } from 'axios'
import { AutenticacaoRemotaUseCase } from '@/usecases/usuario/AutenticacaoRemotaUseCase'


type Page<T> = {
	content: T[]
	number: number
	size: number
	numberOfElements: number
	totalElements: number
	first: boolean
	last: boolean
}

export type Status = 'PENDENTE' | 'LIBERADO' | 'NEGADO' | 'CANCELADO'

@Component({
	components: {
		SeletorDeLojasDoUsuario,
	},
})
export default class TelaDeAutenticacoesRemotas extends Vue {
	@Ref() form!: HTMLFormElement
	
	autenticacoesRemotas: AutenticacaoRemota[] = []
	pagina: Page<AutenticacaoRemota> | null = null

	carregando = false
	loadingId: string | null = null
	loadingAction: 'liberar' | 'negar' | null = null
	cancelToken: CancelTokenSource | null = null

	filtro: {
		status: Status[]
		tipo: TipoDaAutenticacaoRemota | null
		identificador: string | null
		page: number
		size: number
	} = {
		status: ['PENDENTE'],
		tipo: null,
		identificador: null,
		page: 0,
		size: 10,
	}

	statusOptions = [
		{ label: 'Pendente', value: 'PENDENTE' },
		{ label: 'Liberado', value: 'LIBERADO' },
		{ label: 'Negado', value: 'NEGADO' },
		{ label: 'Cancelado', value: 'CANCELADO' },
	]

	tipoOptions = [ 
		{ label: 'Financeiro', value: 'FINANCEIRO' },
		{ label: 'Fiscal', value: 'FISCAL' },
	]

	autenticacaoRemotaUseCase = new AutenticacaoRemotaUseCase()

	async created() {
		await this.buscar()
	}

	corDoStatus(status: StatusDaAutenticacaoRemota) {
		switch (status) {
			case 'Pendente': return 'warning'
			case 'Liberado': return 'success'
			case 'Negado': return 'error'
			case 'Cancelado': return 'grey'
			default: return 'grey'
		}
	}
	
	corDoTipo(tipo: TipoDaAutenticacaoRemota) {
		switch (tipo) {
			case 'Financeiro': return 'blue'
			case 'Fiscal': return 'orange'
			default: return 'grey'
		}
	}

	async aplicarFiltros() {
		this.filtro.page = 0
		await this.buscar()
	}

	async buscar() {
		try {
			this.carregando = true

			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const params = {
				status: this.filtro.status ? this.filtro.status : ['PENDENTE'],
				tipo: this.filtro.tipo ? this.filtro.tipo : undefined,
				identificador: this.filtro.identificador ? this.filtro.identificador : undefined,
				page: this.filtro.page,
				size: this.filtro.size,
				sort: 'createdAt,desc', 
			}

			const page = await this.autenticacaoRemotaUseCase.findAutenticacoesRemotas(params, axiosConfig)
			this.pagina = page
			this.autenticacoesRemotas = page.content || []
		} catch (e) {
			AlertModule.setError('Não foi possível carregar as autenticações remotas')
		} finally {
			this.carregando = false
		}
	}

	async liberar(autenticao: AutenticacaoRemota) {
		try {
			this.loadingId = autenticao.id
			this.loadingAction = 'liberar'
			const atualizada = await this.autenticacaoRemotaUseCase.findById(autenticao.id)
			if (atualizada.status === 'Cancelado') return AlertModule.setError("Solicitação já foi cancelada via caixa. Recarregue a página.")
			await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(autenticao.id, 'Liberado')

			AlertModule.setSuccess('Autenticação liberada')
			await this.buscar()
		} catch (e) {
			AlertModule.setError('Não foi possível liberar a autenticação')
		} finally {
			this.loadingId = null
			this.loadingAction = null
		}
	}

	async negar(autenticao: AutenticacaoRemota) {
		try {
			this.loadingId = autenticao.id
			this.loadingAction = 'negar'
			const atualizada = await this.autenticacaoRemotaUseCase.findById(autenticao.id)
			if (atualizada.status === 'Cancelado') return AlertModule.setError("Solicitação já foi cancelada via caixa. Recarregue a página.")
			await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(autenticao.id, 'Negado')

			AlertModule.setSuccess('Autenticação negada')
			await this.buscar()
		} catch (e) {
			AlertModule.setError('Não foi possível negar a autenticação')
		} finally {
			this.loadingId = null
			this.loadingAction = null
		}
	}

	pagePrevious() {
		if (!this.pagina || this.pagina.first) return
		this.filtro.page = Math.max(0, this.filtro.page - 1)
		this.buscar()
	}

	pageNext() {
		if (!this.pagina || this.pagina.last) return
		this.filtro.page = this.filtro.page + 1
		this.buscar()
	}

	limparFiltros(){
		this.filtro = {
			status: ['PENDENTE'],
			tipo: null,
			identificador: null,
			page: 0,
			size: 10,
		}
		this.buscar()
	}

	regraLabel(regra: string): string {
		const s = (regra || '').trim()
		if (!s) return ''

		const lowerWords = new Set([
			'de', 'do', 'da', 'dos', 'das',
			'sem',
			'no', 'na', 'nos', 'nas',
			'e',
			'em',
			'por',
			'para',
			'ao', 'aos',
			'a', 'à', 'as', 'às'])

		const words = s
			.split('-')
			.filter(Boolean)
			.map(w => w.toLowerCase())

		const result = words.map((w, idx) => {
			const shouldLower = idx !== 0 && lowerWords.has(w)
			if (shouldLower) return w
			return w.charAt(0).toUpperCase() + w.slice(1)
		})

		return result.join(' ')
	}

}
